import { createContext, useContext } from 'react';

const ProfilePreviewContext = createContext({
  openProfilePreview: null,
});

export const useProfilePreview = () => useContext(ProfilePreviewContext);

export default ProfilePreviewContext;
